import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';

import { Block } from '../Block';
import { Typography } from '../Typography';
import { NotFound } from './NotFound';

export const VacancyNotFound: React.FC = () => {
  return (
    <NotFound>
      <Block marginTop={8}>
        <Typography.Text level={4}>
          Этой страницы не существует. Перейдите на Главную и воспользуйтесь поиском
        </Typography.Text>
      </Block>

      <Block marginTop={24}>
        <LinkButton href={'/vacancies/'}>Перейти на Главную</LinkButton>
      </Block>
    </NotFound>
  );
};

VacancyNotFound.displayName = 'VacancyNotFound';
